import { render, staticRenderFns } from "./EinstellungenBelege.vue?vue&type=template&id=6e93358f&"
import script from "./EinstellungenBelege.vue?vue&type=script&lang=js&"
export * from "./EinstellungenBelege.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports